import _ from 'lodash';
import httpClient from '@/core/http/client.service';

const createOrder = (data) => httpClient.post('api/v1/order/start?_format=json', data);
const getOrderInfo = (data) => httpClient.post(`/api/v1/order/info?_format=json&t=${Date.now()}`, data);
const addOrderPatient = (data) => httpClient.post('/api/v1/order/patient/add?_format=json', data);

/* estlint-disable */
// refactoring
const orderInfo = (orderRef, sortPatients, editMode) => httpClient.post(`/api/v1/order/info?_format=json&t=${Date.now()}`, {
  orderRef, sortPatients, editMode
})
  .then((res) => {
    const result = {};
    let hasZeroPatient = false;
    let drugCount = 0;
    result.api = res.data.api;
    result.region = res.data.region;
    result.orderRef = res.data.orderRef;
    result.editRequired = res.data.editRequired;
    result.orderRefView = res.data.orderRefView;
    result.comment = res.data.comment;
    result.deliveryDate = res.data.deliveryDateFormatted;
    result.deliveryTime = res.data.deliveryTimeFormatted;

    result.deliveryDateArray = res.data.deliveryDateArray;

    result.add_more = res.data.add_more;
    result.draftSaved = res.data.draftSaved;
    result.hasOverriddenStability = res.data.hasOverriddenStability;

    // formating patients object to array for easier iteration
    const patientArr = [];

    if (res.data.patients) {
      Object.values(res.data.patients).forEach((patient) => {
        if (typeof patient !== 'string') {
                patientArr.push(patient);
        }
      });
    }
    result.patients = patientArr;

    // for drugs with no patient id, we create a empty patient so keep data structure same as drug's with patient
    const emptyPatient = {
      firstName: '',
      lastName: '',
      patientId: '',
      dateOfBirth: '',
      drugs: [],
    };

    // formating drugs object
    if (res?.data?.drugs) {
        Object.entries(res.data.drugs).forEach((row) => {
        if (row[0] !== '0' && row[0] !== '') {
            const patient = patientArr.find((p) => p.patientId === row[0]);
            if (patient) {
                const k = _.values(row[1]);
                patient.drugs = k;
                patient.drugs.forEach((drug) => {
                    if (drug.deliveryDateArray) {
                        drugCount += (drug.deliveryDateArray.length);
                    } else {
                        drugCount += (1);
                    }
                });
            }
        }

        if (row[0] === '0') {
          const i = _.values(row[1]);
          emptyPatient.drugs = i;
          hasZeroPatient = true;
            emptyPatient.drugs.forEach((drug) => {
                if (drug.deliveryDateArray) {
                    drugCount += (drug.deliveryDateArray.length);
                } else {
                    drugCount += (1);
                }
            });
        }
      });
    }

    if (hasZeroPatient) {
      patientArr.push(emptyPatient);
    }

    result.drugCount = drugCount;
    result.patientCount = _.values(res.data.patients).length;
    return result;
  });

const submitOrder = (data) => httpClient.post('/api/v1/order/submit?_format=json', data);

const validateOrder = (data) => httpClient.post('api/v1/order/submit?_format=json', data);

const submitDraftOrder = (data) => httpClient.post('/api/v1/order/draft?_format=json', data);

const deleteDraftOrder = (data) => httpClient.delete('/api/v1/order/draft/' + data.replace('/', '%25252F').replace('\\', '%25255C') + '?_format=json');

const orderStatusInfo = (data) => httpClient.get('/api/v1/dashboard/order/summary?_format=json&type=' + data.type);

const orderTypeList = () => httpClient.post('/api/v1/dashboard/orders?_format=json', {
  type: 'home',
}, {
  headers: {
    'Content-Type': 'application/json',
  },
});

const tpnOrders = () => httpClient.post('/api/v1/dashboard/orders?_format=json', {
  type: 'tpn',
}, {
  headers: {
    'Content-Type': 'application/json',
  },
});

const searchOrder = (criteria) => httpClient.post('/api/v1/dashboard/order-search?_format=json', {
    orderRef: criteria.keyword,
    type: criteria.type,
});

const searchOrderAdvanced = (criteria) => httpClient.post('/api/v1/dashboard/order-search-advanced?_format=json', {
    criteria,
});

const searchOrders = (criteria) => httpClient.post('/api/v1/order/search?_format=json', {
    searchCriteria: criteria,
});

const searchOrderByType = (type) => httpClient.post('/api/v1/dashboard/orders?_format=json', {
  type,
}, {
  headers: {
    'Content-Type': 'application/json',
  },
});

const getOrderDetail = (orderId) => httpClient.post('/api/v1/dashboard/order/details?_format=json', {
  groupOrderId: orderId,
});

const getOrderDetailAsync = (data) => httpClient.post('/api/v1/dashboard/order/details?_format=json', data);

const getTpnOrderDetail = (orderId) => httpClient.post('/api/v1/dashboard/order/details?_format=json', {
  groupOrderId: orderId,
  type: 'TPN',
});

const updateOrder = (data) => httpClient.post('/api/v1/dashboard/order/manage?_format=json', data);

const cancelOrder = (data) => httpClient.post('/api/v1/dashboard/order/cancel?_format=json', data);

const orderCleanup = async (data) => httpClient.post('/api/v1/order/cleanup?_format=json', data);

export default {
  createOrder,
  validateOrder,
  getOrderInfo,
  addOrderPatient,
  orderInfo,
  orderCleanup,
  submitOrder,
  submitDraftOrder,
  deleteDraftOrder,
  orderStatusInfo,
  orderTypeList,
  tpnOrders,
  searchOrder,
  searchOrderAdvanced,
  searchOrders,
  searchOrderByType,
  getOrderDetail,
  getOrderDetailAsync,
  getTpnOrderDetail,
  updateOrder,

  cancelOrder,
};
